import { useEffect } from 'react';
import { atoms } from '@fiverr-private/theme';
import { DynamicSection } from '@fiverr-private/ai_brief';
import { Gql } from '@fiverr-private/dynamic_matching';
import { BriefNeedType } from '../../NeedType';
import { useBriefCreationContext } from '../../../../context/BriefCreationContext';
import { BudgetAndTimelineContent, timeUnits } from './types';

export const numberRegex = /^[\d,.]*$/;

export const spacingForControls = atoms({
    paddingTop: '3',
});

export const useNeedType = () => {
    const { brief } = useBriefCreationContext();
    const needTypeSection = brief?.sections?.find((section) => section.id === 'need_type') as DynamicSection;

    return { needType: (needTypeSection?.content as BriefNeedType)?.needType };
};

interface UseHandleTimelineParams {
    needType: Gql.DmBriefNeedType;
    sectionContentState: BudgetAndTimelineContent;
    setSectionContentState: (state: BudgetAndTimelineContent) => void;
}

export const useSetOngoingTimeline = ({
    sectionContentState,
    setSectionContentState,
    needType,
}: UseHandleTimelineParams) => {
    useEffect(() => {
        if (needType === Gql.DmBriefNeedType.Ongoing) {
            setSectionContentState({ ...sectionContentState, timeline: Gql.DmBriefTimeline.Ongoing });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export const buildSectionContentStateFromContent = (
    content: BudgetAndTimelineContent,
    needType: Gql.DmBriefNeedType | undefined
): BudgetAndTimelineContent => ({
    pricingType:
        content.pricingType ??
        (!needType || needType === Gql.DmBriefNeedType.OneTime
            ? Gql.BriefPricingType.Fixed
            : Gql.BriefPricingType.Hourly),
    budgetInCents: content.budgetInCents,
    hourlyBudgetRange: {
        min: content.hourlyBudgetRange?.min,
        max: content.hourlyBudgetRange?.max ?? 0,
    },
    timeline: content.timeline,
    deliveryDate: content.deliveryDate,
    timelineDetails: {
        generalTimeline: {
            value: content.timelineDetails?.generalTimeline?.value,
            unit: content.timelineDetails?.generalTimeline?.unit ?? timeUnits.weeks,
        },
        timeCommitment: content.timelineDetails?.timeCommitment,
        hiringDuration: content.timelineDetails?.hiringDuration,
        deliveriesFrequency: {
            value: content.timelineDetails?.deliveriesFrequency?.value,
            unit: content.timelineDetails?.deliveriesFrequency?.unit ?? timeUnits.weeks,
        },
    },
});

export const getCommaFormatedStringAsNumber = (value: string) => (!value ? 0 : parseFloat(value.replace(/,/g, '')));
export const formatNumberWithComma = (number) => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
